/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_25_TitleInputs */

const es_gift_option_25_title = /** @type {(inputs: Gift_Option_25_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante de Muelle`)
};

const gl_gift_option_25_title = /** @type {(inputs: Gift_Option_25_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante de Pantalán`)
};

const en_gift_option_25_title = /** @type {(inputs: Gift_Option_25_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dock Beginner`)
};

/**
* | output |
* | --- |
* | "Dock Beginner" |
*
* @param {Gift_Option_25_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_25_title = /** @type {((inputs?: Gift_Option_25_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_25_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_25_title(inputs)
	if (locale === "en") return en_gift_option_25_title(inputs)
	return es_gift_option_25_title(inputs)
});